import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AgGridModule} from 'ag-grid-angular';


//COMPONENTES SHARED
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import {SharedModule} from 'src/app/shared/shared.module';
import { PerformModule } from './io-industrias-routing.module';
import { ReportePerformComponent } from './views/reporte-perform/reporte-perform.component';
import { MantenedorOrdenProcesoPerformComponent } from './views/mantenedor-ordenproceso-perform/mantenedor-ordenproceso-perform.component';
import { ReportePerformSendedComponent } from './views/reporte-perform-sended/reporte-perform-sended.component';
import { ReportePerformDetailComponent } from './views/reporte-perform-detail/reporte-perform-detail.component';
import { ReporteGaussComponent } from './views/reporte-gauss/reporte-gauss.component';
import { MantenedorProductoSpecsComponent } from './views/mantenedor-producto-specs/mantenedor-producto-specs.component';
import { TooltipModule } from 'ng2-tooltip-directive';
import { MantenedorProductoLogsComponent } from './views/mantenedor-producto-logs/mantenedor-producto-logs.component';
import { ReporteParetoComponent } from './views/reporte-pareto/reporte-pareto.component';
import { BitacoraSeguimientoPerformComponent } from './views/bitacora-seguimiento-perform/bitacora-seguimiento-perform.component';
import { MantenedorBalanzadeLineaComponent } from './views/mantenedor-balanzade-linea/mantenedor-balanzade-linea.component';
import { CapturadorPesoComponent } from './views/capturador-peso/capturador-peso.component';



@NgModule({
  declarations: [
    ReportePerformComponent,
    MantenedorOrdenProcesoPerformComponent,
    ReportePerformSendedComponent,
    ReportePerformDetailComponent,
    ReporteGaussComponent,
    MantenedorProductoSpecsComponent,
    MantenedorProductoLogsComponent,
    ReporteParetoComponent,
    BitacoraSeguimientoPerformComponent, //Ticket 30238 LOG de ingreso en modulos perform
    MantenedorBalanzadeLineaComponent, 
    CapturadorPesoComponent, 
  ],
  exports: [
    ReportePerformComponent
  ],
  imports: [
    CommonModule,
    PerformModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    TooltipModule,
    SharedModule,
    AgGridModule.withComponents([LfsaBotonEditarGridComponent]),
  ]
})
export class IoIndustiasModule {
}
